module.exports = __webpack_public_path__ + "static/media/ai-ad-ossoffMOBILE.06eaca2c.mp4";